import isBoolean from "lodash/isBoolean";
import isNil from "lodash/isNil";
export const valueFormatterBooleanYN = (params) => {
  if (isNil(params?.value)) {
    return "No";
  }

  if (isBoolean(params?.value) && params?.value) {
    return "Yes";
  }
  return "No";
};
